module.exports = __webpack_public_path__ + "fonts/56482a43b169bd005a4d3d8cf8bd4659-Roboto-LightItalic.eot";